import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    chipValid: {
        borderStyle: "solid",
        borderWidth: 1,
        borderRadius: 15,
        borderColor: theme.palette.secondary.main,
        margin: 2
    },
    chipInvalid: {
        borderStyle: "solid",
        borderWidth: 2,
        borderRadius: 15,
        borderColor: theme.palette.error.main,
        margin: 2,
        textDecoration: "line-through"
    }
}));

export {useStyles};
